export const safeMap = <T, U>(arr: T[] | null | undefined, fn: (t: T) => U, fallback: U[]): U[] =>
	Array.isArray(arr) ? arr.map(fn) : fallback

export const safeMapOrNull = <T, U>(arr: T[] | null | undefined, fn: (t: T) => U): U[] | null =>
	Array.isArray(arr) ? arr.map(fn) : null

export const safeLangContent = (value: ILangContent[] | null | undefined): ILangContentModel =>
	Array.isArray(value) ? LangContentToModel(value) : { pl: '' }

export const transToLang = (s: string | null | undefined): ILangContent[] => (s ? [{ lang: 'pl', content: s }] : [])
